var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Vyberte hypotéku")])]), _c('div', {
    staticClass: "w-form"
  }, [_vm._l(_vm.mortgages, function (mortgage, key) {
    return _c('div', {
      key: key,
      staticClass: "input-block p-relative"
    }, [_c('div', {
      staticClass: "div-block-101"
    }, [_c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "primary"
    }, [_vm._v(" " + _vm._s(_vm.getChoicesFromFormByKey("hlavny_ucel", mortgage.hlavny_ucel)) + " ")]), _c('div', {
      staticClass: "light-text"
    }, [_vm._v(" " + _vm._s(_vm.getChoicesFromFormByKey("stage", mortgage.stage)) + " od " + _vm._s(_vm.getDate(mortgage.modified)) + " ")])]), _c('div', {
      staticClass: "black"
    }, [_vm._v(_vm._s(_vm.getMortgageAmount(mortgage)) + " EUR")])]), mortgage.stage === 'zrusena' ? _c('div', {
      staticClass: "div-block-112"
    }, [_c('div', {
      staticClass: "text-cta",
      on: {
        "click": function click($event) {
          return _vm.restoreMortgage(mortgage);
        }
      }
    }, [_vm._v("OBNOVIŤ")])]) : _vm._e(), _c('div', {
      staticClass: "div-block-112"
    }, [_c('div', {
      staticClass: "text-cta",
      on: {
        "click": function click($event) {
          return _vm.openMortgage(mortgage.id);
        }
      }
    }, [_vm._v(_vm._s(_vm.payload.title))])])]);
  }), _vm.payload.title === 'EDIT' ? _c('div', {
    staticClass: "sub-popup-wrapper"
  }, [_c('div', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.createMortgage();
      }
    }
  }, [_vm._v("+ založiť ďalšiu HYPOTÉKU")])]) : _vm._e()], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }